import { Dispatch, SetStateAction } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const ModalInfoBiseries = ({ isOpen, setIsOpen }: Props) => {
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} fullWidth>

      <DialogTitle className='flex justify-center text-orangeTr4iner'> Biserie </DialogTitle>

      <DialogContent className='font-medium' dividers>
        Se refiere a realizar un ejercicio seguido de otro, sin descanso entre ellos, únicamente al terminar una serie de ambos se descansa
      </DialogContent>

      <DialogActions>
        <button
          onClick={() => setIsOpen(false)}
          className="text-white bg-black p-2 rounded-lg"
        >
          Cerrar
        </button>
      </DialogActions>

    </Dialog>
  )
}

export default ModalInfoBiseries;
